import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const pauseChatAction = createAsyncAction(
  '@chat/PAUSE_CHAT_REQUEST',
  '@chat/PAUSE_CHAT_SUCCESS',
  '@chat/PAUSE_CHAT_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingPauseChat: true
})

const success = (state: ChatState, action: ActionType<typeof pauseChatAction.success>): ChatState => {
  const { updatedChatData } = action.payload

  return {
    ...state,
    activeChat: { ...state.activeChat, ...updatedChatData },
    isSuccessOnPauseChat: true,
    isLoadingPauseChat: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingPauseChat: false,
  isErrorOnPauseChat: true
})

export const pauseChatHandle = { asyncAction: pauseChatAction, request, success, failure }
